import { Controller } from "@hotwired/stimulus";
import { track } from "../analytics";

export default class extends Controller {
  connect() {
    // Track pricing section view when it becomes visible
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            track("pricing_section_viewed");
            observer.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(this.element);
  }

  trackCtaClick(event) {
    const location = event.target.dataset.location || "pricing_section";
    const planName = event.target.dataset.planName || "unknown";

    track("cta_book_call_clicked", {
      location: location,
      plan_name: planName,
    });
  }

  trackCheckoutClick(event) {
    const el = event.target.closest("[data-location]") || event.target;
    const planName = el.dataset.planName || "unknown";

    track("checkout_clicked", {
      plan_name: planName,
    });
  }
}
